import { request } from "../request";
const mock = "";
// const mock1 = "https://yapi.upho2015.com/mock/530";
// 获取作业详情
export const getWorkInfo = (params) =>
  request(`${mock}/v1/workManage/get`, "get", { params });
// 获取作业题目列表
export const getQuestionList = (params) =>
  request(`${mock}/v1/workManage/getQuestionList`, "get", { params });
// 获取作业题目
export const getQuestionInfo = (params) =>
  request(`${mock}/v1/workManage/getQuestion`, "get", { params });
// 答题
export const answerQuestion = (params) =>
  request(`${mock}/v1/workManage/answer`, "post", { json: params });
//提交
export const submitWork = (params) =>
  request(`${mock}/v1/workManage/submit`, "get", { params });
//提交打卡
export const submitWorkTask = (params) =>
  request(`${mock}/v1/clockIn/userTask/create`, "post", { json: params });
//标记题目
//标记题目
export const markerQuestion = (params) =>
  request(`${mock}/v1/workManage/markers`, "post", { json: params });
//获取同学答题情况
export const getStudentWork = (params) =>
  request(`${mock}/v1/workManage/getStudentWork`, "get", { params });
//设置仅老师可见
export const onlyTeacherLook = (params) =>
  request(`${mock}/v1/workManage/onlyTeacherLook`, "post", { json: params });
//提交举报
export const submitReport = (params) =>
  request(`${mock}/v1/complaint/create`, "post", { json: params });
